import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Globe, Instagram, MapPin, Flame, Youtube, Facebook } from 'lucide-react';
import { BRAND } from '../data/mock';

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-orange-500/20 mt-20">
      <div className="absolute inset-0 pointer-events-none opacity-30" style={{
        background: 'radial-gradient(circle at 15% 0%, rgba(249,115,22,.25), transparent 40%), radial-gradient(circle at 85% 100%, rgba(234,88,12,.2), transparent 45%)'
      }} />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={BRAND.logo} alt="logo" className="w-20 h-20 object-contain drop-shadow-[0_4px_12px_rgba(249,115,22,0.45)]" />
            <div>
              <div className="font-display text-2xl tracking-wider">ZAYKA <span className="text-orange-500">SPHERE</span></div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400/80">{BRAND.tagline}</div>
            </div>
          </div>
          <p className="text-white/60 text-sm leading-relaxed">Bold burgers, momos, pasta, shakes and more. A growing global food brand serving crazy flavours across formats.</p>
          <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-orange-500/40 text-orange-400 text-xs uppercase tracking-widest">
            <Flame className="w-3.5 h-3.5" /> Crazy Food. Crazy Mood.
          </div>
        </div>

        <div>
          <h4 className="font-bebas text-xl text-orange-500 mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/" className="hover:text-orange-400">Home</Link></li>
            <li><Link to="/menu" className="hover:text-orange-400">Menu</Link></li>
            <li><Link to="/franchise" className="hover:text-orange-400">Franchise</Link></li>
            <li><Link to="/global-expansion" className="hover:text-orange-400">Global Expansion</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bebas text-xl text-orange-500 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 text-orange-500 mt-0.5" /><a href={`tel:${BRAND.phone}`}>{BRAND.phone}</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-orange-500 mt-0.5" /><a href={`mailto:${BRAND.email}`}>{BRAND.email}</a></li>
            <li className="flex items-start gap-2"><Globe className="w-4 h-4 text-orange-500 mt-0.5" />{BRAND.website}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-orange-500 mt-0.5" />India — Expanding Globally</li>
          </ul>
        </div>

        <div>
          <h4 className="font-bebas text-xl text-orange-500 mb-4">Follow The Craze</h4>
          <p className="text-white/60 text-sm mb-4">Get behind the scenes, new drops and crazy deals.</p>
          <div className="flex flex-wrap gap-2.5">
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram" aria-label="Instagram" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm uppercase tracking-wider transition hover:scale-105">
              <Instagram className="w-4 h-4" /> {BRAND.ig_handle}
            </a>
            <a href={BRAND.youtube} target="_blank" rel="noreferrer" data-testid="social-youtube" aria-label="YouTube" className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white/5 border border-white/10 text-white/80 hover:bg-red-600 hover:text-white hover:border-red-600 transition hover:scale-105">
              <Youtube className="w-5 h-5" />
            </a>
            <a href={BRAND.facebook} target="_blank" rel="noreferrer" data-testid="social-facebook" aria-label="Facebook" className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white/5 border border-white/10 text-white/80 hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2] transition hover:scale-105">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Zayka Sphere. All rights reserved.</div>
          <div className="font-marker text-orange-400/80 text-sm">Crazy Food for Crazy You!</div>
        </div>
      </div>
    </footer>
  );
}
